/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function ConvertCellToDefaultRequestFromJSON(json) {
    return ConvertCellToDefaultRequestFromJSONTyped(json, false);
}
export function ConvertCellToDefaultRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        tagIds: json['tagIds'],
    };
}
export function ConvertCellToDefaultRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        tagIds: value.tagIds,
    };
}
